import { useQuery } from '@tanstack/react-query';
import { fetchRequest } from '@api/RequestApi';
import type { BusinessUnit, ID } from 'types';

const bidRequestBusinessUnitQueryKey = (bidRequestId: ID | undefined) =>
  ['bid_requests', bidRequestId, 'business_unit'] as const;

export const useBidRequestBusinessUnit = (
  bidRequestId: ID | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  return useQuery({
    enabled: !!bidRequestId && enabled,
    queryFn: async (): Promise<BusinessUnit | null> => {
      const response = await fetchRequest(bidRequestId, '');
      if (!response.success) throw new Error(response.errors?.[0]);

      return response.bid_request.business_unit ?? null;
    },
    queryKey: bidRequestBusinessUnitQueryKey(bidRequestId),
  });
};
